export default function ChevronDown(props) {
    const { color = "currentColor", size = 30, className } = props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 30 30"
        className={className}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m10 12 5 5 5-5"
        />
      </svg>
    );
  }
  